import { gql } from "@apollo/client";

export const UpdateRectangleBannerWide = gql`
mutation UpdateRectangleBannerWide($updateRectangleBannerWideId: ID!, $content: contentRectangleBanner!) {
  updateRectangleBannerWide(id: $updateRectangleBannerWideId, content: $content) {
    status
  }
}
`;
